import React from 'react';
import Contact from '../components/Contact';

const ContactContainer = () => {
  return (
    <div className="containers one-second-animation">
      <Contact />
    </div>
  );
};

export default ContactContainer;
